"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _typed = require('shared/hooks/typed');
var _scheduledMessages = require('shared/selectors/scheduledMessages');
var _user = require('shared/selectors/user');
var _timeZones = require('shared/services/timeZones');

// localStorage on web and desktop, AsyncStorage on mobile.





const storageKey = (userKey) => `bt_schedule_time_zone_${userKey}`

/* The zone the user schedules in, and a way to change it. The choice is
 * remembered per user on this device and read back the first time a chat
 * opens; storage that can't be read or written leaves the device's zone. */
 const useScheduleTimeZone = (storage) => {
  const dispatch = _typed.useAppDispatch.call(void 0, )
  const userKey = _typed.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const timeZone = _typed.useAppSelector.call(void 0, _scheduledMessages.selectScheduleTimeZone)
  const chosen = _typed.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([state, 'access', _ => _.scheduledMessages, 'optionalAccess', _2 => _2.timeZone]), () => ( null)))

  _react.useEffect.call(void 0, () => {
    if (!userKey || chosen) return
    let current = true
    Promise.resolve()
      .then(() => storage.getItem(storageKey(userKey)))
      .then((stored) => {
        if (current && _timeZones.isTimeZone.call(void 0, stored)) dispatch(_actionCreators2.default.setScheduleTimeZoneAction(stored, true))
      })
      .catch(() => undefined)
    return () => { current = false }
  }, [dispatch, storage, userKey, chosen])

  const setTimeZone = _react.useCallback.call(void 0, (zone) => {
    if (!_timeZones.isTimeZone.call(void 0, zone)) return
    dispatch(_actionCreators2.default.setScheduleTimeZoneAction(zone))
    if (!userKey) return
    Promise.resolve()
      .then(() => storage.setItem(storageKey(userKey), zone))
      .catch(() => undefined)
  }, [dispatch, storage, userKey])

  return { timeZone, setTimeZone }
}; exports.useScheduleTimeZone = useScheduleTimeZone
